/**
 * @generated SignedSource<<b243fe47095c4ae2880a0d940b6f0799>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhotosSearchBrowsePhotoContainerMobile_photos$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly height: number | null;
      readonly id: string;
      readonly name: string | null;
      readonly path: string | null;
      readonly room: {
        readonly name: string | null;
      } | null;
      readonly serviceId: string | null;
      readonly styles: ReadonlyArray<{
        readonly name: string | null;
      } | null> | null;
      readonly url: string | null;
      readonly width: number | null;
      readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowseSocialIcons_photo">;
    } | null;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowsePhotoPreviewPhotoSwiper_photos" | "PhotosSearchBrowseSocialIcons_photos">;
  readonly " $fragmentType": "PhotosSearchBrowsePhotoContainerMobile_photos";
};
export type PhotosSearchBrowsePhotoContainerMobile_photos$key = {
  readonly " $data"?: PhotosSearchBrowsePhotoContainerMobile_photos$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowsePhotoContainerMobile_photos">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PhotosSearchBrowsePhotoContainerMobile_photos",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PhotosSearchBrowseSocialIcons_photos"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PhotosSearchBrowsePhotoPreviewPhotoSwiper_photos"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PhotosSearchBrowseQueryEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PhotosSearchBrowsePhoto",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PhotosSearchBrowseSocialIcons_photo"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "path",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "width",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "height",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "TradePhotoStyle",
              "kind": "LinkedField",
              "name": "styles",
              "plural": true,
              "selections": (v1/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "TradePhotoStyle",
              "kind": "LinkedField",
              "name": "room",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PhotosSearchBrowseQueryConnection",
  "abstractKey": null
};
})();

(node as any).hash = "22a84c0a7406c2ea00c0bdbdb142fc7e";

export default node;
